import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "SVGRepo_bgCarrier",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
      _createElementVNode("circle", {
        cx: "12",
        cy: "7",
        r: "4",
        stroke: "#000000",
        "stroke-width": "1"
      }),
      _createElementVNode("path", {
        d: "M14.9999 14H8.99991C6.23848 14 3.76499 16.5498 5.58239 18.6289C6.81829 20.0428 8.86211 21 11.9999 21C15.1377 21 17.1815 20.0428 18.4174 18.6289C20.2348 16.5498 17.7613 14 14.9999 14Z",
        stroke: "#000000",
        "stroke-width": "1"
      })
    ], -1)
  ])))
}